import * as es6promise from "es6-promise";
import { util, GetEditInfo, SenderInfoDb } from "../index";
import { Logger } from "../util/logger";

import * as edconst from "./edit.const";
import * as edtool from "./edit.tool";


//------------------------------------------------------------------------------
// エンティティ・クラス
//------------------------------------------------------------------------------

/**
 * WebAPI[Edit/InitTemp]のレスポンスのdata部
 */
export class initTempResponseEntity {
    /**
     * クライアントでのチェック用
     */
    public photoControll: photoControll
}

/**
 * クライアントでのチェック用
 */
export class photoControll {

    /**
     *  iDBの画像情報を残すか？
     */
    public leavePhoto: boolean;
    /**
     * テンポラリで保持している画像枚数
     */
    public photoNum: number;
}

/**
 * WebAPI[Edit/UploadImage]のレスポンスのdata部
 */
export class UploadImageResponseEntity {

    /**
     * ファイル実体
     */
    public fileObject: File;
    /**
     * MD5
     */
    public md5: string;
    /**
     * ファイルID
     */
    public fileId: string;
    /**
     * 実サイズ(px) 幅
     */
    public width: number;
    /**
     * 実サイズ(px) 高さ
     */
    public height: number;

}

/**
 * アップロード画像ファイルクラス
 */
export class uploadPhoto {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------

    /**
     * イメージアップロード情報テーブルのキー情報
     */
    public fileId: string;
    /**
     * sonbpが使用するファイル識別子（暗号化）
     */
    public fileKey: string;
    /**
     * ファイル名（オリジナル）
     */
    public fileName: string;
    /**
     * 画像サイズ縦(px)
     */
    public height: number;
    /**
     * 画像サイズ横(px)
     */
    public width: number;
    /**
     * 回転角度
     */
    public angle: number;
    /**
     * アップロード日時
     */
    public uploadDate: Date;
    /**
     * 削除日時
     */
    public deleteDate: Date;
    /**
     * 削除フラグ
     */
    public deleteFlg: boolean;
    /**
     * 使用有無
     */
    public isUsed: boolean;

    /**
    * 設定有無(空枠判定)
    */
    public isEmpty: boolean;

    /**
     * サムネイル取得用URL
     */
    public thumbnailUrl: string;
    /**
     * キー
     */
    public key: string;
    /**
     * 削除指示フラグ
     */
    public reqDelete: boolean;

    /**
     * 選択指示フラグ
     * SP専用
     */
    public selected: string;


    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------
    constructor() {
        this.isEmpty = true;
        this.isUsed = false;
        this.deleteFlg = false;
        this.thumbnailUrl = "/posca/img/sp/common/default/touka.png";
        this.fileKey = "";
        this.reqDelete = false;
        this.selected = edconst.EditConst.IMG_NOSELECT;
    }


}

/**
 * 画像枠クラス
 */
export class photoFrame {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------

    /**
     * 識別子
     */
    public idx: string;
    /**
     * イメージアップロード情報テーブルのキー情報
     */
    public fileId: string;
    /**
     * I2補正した画像が適用されているか
     */
    public useI2: boolean;
    /**
     * 明るさ
     */
    public brightId: number;

    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------
    constructor() {
        this.idx = "";
        this.fileId = "";
        this.useI2 = true;
        this.brightId = 0;
    }
}

/**
 * あいさつ文 トランザクション情報＋α
 */
export class greetingTranEntityEx extends GetEditInfo.GetEditInfoGreetingTranEntity {

    // 選択したフォントマスタ
    public fontMaster: GetEditInfo.GetEditInfoFontEntity;
    // 文字レイアウト
    public charLayout: string;
    // フチ文字にする
    public outlineChar: boolean;
    // 選択した文字色マスタ
    public fontColorMaster: GetEditInfo.GetEditInfoColorEntity;
    // 選択したフチ文字色マスタ
    public outlineFontColorMaster: GetEditInfo.GetEditInfoColorEntity;
    // 行揃え(表示値)
    public alignDispVal: string;
}

/**
 * 差出人 トランザクション情報＋α
 */
export class senderTranEntityEx {

    // 編集情報取得(WebAPI)で連携される差出人情報本体
    public sender: GetEditInfo.GetEditInfoSenderEntity;

    // 選択したフォントマスタ
    public fontMaster: GetEditInfo.GetEditInfoFontEntity;
    // 文字レイアウト
    public charLayout: string;
    // フチ文字にする
    public outlineChar: boolean;
    // 選択した文字色マスタ
    public fontColorMaster: GetEditInfo.GetEditInfoColorEntity;
    // 選択したフチ文字色マスタ
    public outlineFontColorMaster: GetEditInfo.GetEditInfoColorEntity;
    // 行揃え(表示値)
    public alignDispVal: string;

    // 電話番号種別(表示値)
    public Tel1DispVal: string;
    public Tel2DispVal: string;


    static createDef(senderMaster: GetEditInfo.DesignDetailEntity, fontMaster: GetEditInfo.GetEditInfoFontEntity[], colorMaster: GetEditInfo.GetEditInfoColorEntity[]): senderTranEntityEx {

        let newItem: senderTranEntityEx = new senderTranEntityEx();

        newItem.fontMaster = fontMaster[0];
        newItem.charLayout = edtool.editUtil.directionToCharlayout(senderMaster.direction);
        //newItem.alignDispVal = editUtil.alignToAlignDispVal(newItem.charLayout, senderMaster.align);
        newItem.outlineChar = false;
        newItem.fontColorMaster = colorMaster[0];
        newItem.outlineFontColorMaster = colorMaster[0];
        newItem.Tel1DispVal = edconst.EditConst.CONTACT_TEL_DISP;
        newItem.Tel2DispVal = edconst.EditConst.CONTACT_TEL_DISP;

        newItem.sender = new GetEditInfo.GetEditInfoSenderEntity();

        newItem.sender.type = "";
        newItem.sender.font = "";
        newItem.sender.size = 0;
        newItem.sender.senderInfo = new SenderInfoDb.SenderInfoDbEntity();
        newItem.sender.senderInfo.addresses = [];
        newItem.sender.senderInfo.corps = [];
        newItem.sender.senderInfo.names = [];
        newItem.sender.senderInfo.emails = [];
        newItem.sender.senderInfo.free = ""
        newItem.sender.senderInfo.staff = ""
        newItem.sender.senderInfo.isHojin = false;

        let defAddress: SenderInfoDb.SenderInfoAddressDbEntity = new SenderInfoDb.SenderInfoAddressDbEntity();
        defAddress.topstr = "";
        defAddress.yubin1 = "";
        defAddress.yubin2 = "";
        defAddress.jusho1 = "";
        defAddress.jusho2 = "";
        defAddress.jusho3 = "";
        defAddress.telType1 = 0;
        defAddress.telTopStr1 = "";
        defAddress.telNo1_1 = "";
        defAddress.telNo1_2 = "";
        defAddress.telNo1_3 = "";
        defAddress.telEndStr1 = "";
        defAddress.telType2 = 0;
        defAddress.telTopStr2 = "";
        defAddress.telNo2_1 = "";
        defAddress.telNo2_2 = "";
        defAddress.telNo2_3 = "";
        defAddress.telEndStr2 = "";
        let defCorp: SenderInfoDb.SenderInfoCorpDbEntity = new SenderInfoDb.SenderInfoCorpDbEntity();
        defCorp.maekabu = "";
        defCorp.name = "";
        defCorp.busyo = "";
        let defNames: SenderInfoDb.SenderInfoNameDbEntity = new SenderInfoDb.SenderInfoNameDbEntity();
        defNames.title = "";
        defNames.firstName = "";
        defNames.firstRubi = "";
        defNames.lastName = "";
        defNames.lastRubi = "";
        defNames.ps = "";
        let defEmail: SenderInfoDb.SenderInfoEmailDbEntity = new SenderInfoDb.SenderInfoEmailDbEntity();
        defEmail.topstr = "";
        defEmail.type = 0;
        defEmail.address = "";
        defEmail.endstr = "";

        newItem.sender.senderInfo.addresses.push(defAddress);
        newItem.sender.senderInfo.addresses.push(defAddress);
        newItem.sender.senderInfo.corps.push(defCorp);
        newItem.sender.senderInfo.names.push(defNames);
        newItem.sender.senderInfo.names.push(defNames);
        newItem.sender.senderInfo.names.push(defNames);
        newItem.sender.senderInfo.names.push(defNames);
        newItem.sender.senderInfo.names.push(defNames);
        newItem.sender.senderInfo.names.push(defNames);
        newItem.sender.senderInfo.emails.push(defEmail);
        newItem.sender.senderInfo.emails.push(defEmail);

        return newItem;
    }

}


// #region ■Kumihan

/**
 * 組版の担当クラス
 */
export class kumihanContoroller {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------
    /**
     * あいさつ文生成(WebAPI)呼び出しURL
     */
    private readonly WEBAPI_URL_GREETING: string = "Typeset/KumihanGreeting";

    /**
     * 差出人生成(WebAPI)呼び出しURL
     */
    private readonly WEBAPI_URL_SENDER: string = "Typeset/KumihanSender";


    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------

    /**
     * 組版サービスURL
     */
    private kumihanUrl: string;

    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------
    /**
     * コンストラクタ
     * */
    constructor(kumihanUrl: string) {
        this.kumihanUrl = kumihanUrl
    }

    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------

    /**
     * あいさつ文 組版API 実行
     * @param inputParam 入力情報
     */
    public async doKumihanGreeting(inputParam: kumihanGreetingRequestParam): es6promise.Promise<kumihanResponseParam> {

        let result: kumihanResponseParam = null;

        Logger.debug("あいさつ文 組版実行準備 [" + JSON.stringify(inputParam) + "]");

        // 入力パラメータ
        const param = {
            session: inputParam.session,
            params: {
                hv: inputParam.hv.valueOf(),
                msize: inputParam.msize,
                pivot: inputParam.pivot,
                // 組版用の縦横で組む
                width: inputParam.widthKumi,
                height: inputParam.heightKumi,
                ftype: inputParam.ftype,
                color1: inputParam.color1,
                color2: inputParam.color2,
                vertGreetConvType: inputParam.vertGreetConvType
            },
            payload: inputParam.payload
        };

        Logger.log("あいさつ文 組版実行 [" + JSON.stringify(param) + "]");

        await util.ajax.post(this.kumihanUrl + this.WEBAPI_URL_GREETING, JSON.stringify(param)).then((resData: kumihanResponseParam) => {

            Logger.debug("あいさつ文 組版結果OK [" + JSON.stringify(resData) + "]");

            result = resData;
        }).catch((e: Error) => {

            Logger.error("あいさつ文 組版結果NG", e);

        });

        return result;

    }

    /**
     * 差出人 組版API 実行
     * @param inputParam 入力情報
     */
    public async doKumihanSender(inputParam: kumihanSenderRequestParam): es6promise.Promise<kumihanResponseParam> {

        let result: kumihanResponseParam = null;

        Logger.debug("差出人 組版実行準備 [" + JSON.stringify(inputParam) + "]");

        // 入力パラメータ
        const param = {
            session: inputParam.session,
            params: {
                layout_cd: inputParam.layout_cd,
                hv: inputParam.hv.valueOf(),
                msize: inputParam.msize,
                pivot: inputParam.pivot,
                width: inputParam.width,
                height: inputParam.height,
                ftype: inputParam.ftype,
                color1: inputParam.color1,
                color2: inputParam.color2
            },
            payload: {
                adr1_topstr: inputParam.adr1_topstr,
                adr1_post1: inputParam.adr1_post1,
                adr1_post2: inputParam.adr1_post2,
                adr1_adr1: inputParam.adr1_adr1,
                adr1_adr2: inputParam.adr1_adr2,
                adr1_adr3: inputParam.adr1_adr3,
                adr1_teltype1: inputParam.adr1_teltype1,
                adr1_teltopstr1: inputParam.adr1_teltopstr1,
                adr1_telno1: inputParam.adr1_telno1,
                adr1_telno11: inputParam.adr1_telno11,
                adr1_telno12: inputParam.adr1_telno12,
                adr1_telno13: inputParam.adr1_telno13,
                adr1_telendstr1: inputParam.adr1_telendstr1,
                adr1_teltype2: inputParam.adr1_teltype2,
                adr1_teltopstr2: inputParam.adr1_teltopstr2,
                adr1_telno2: inputParam.adr1_telno2,
                adr1_telno21: inputParam.adr1_telno21,
                adr1_telno22: inputParam.adr1_telno22,
                adr1_telno23: inputParam.adr1_telno23,
                adr1_telendstr2: inputParam.adr1_telendstr2,
                adr1_teltype3: inputParam.adr1_teltype3,
                adr1_teltopstr3: inputParam.adr1_teltopstr3,
                adr1_telno3: inputParam.adr1_telno3,
                adr1_telno31: inputParam.adr1_telno31,
                adr1_telno32: inputParam.adr1_telno32,
                adr1_telno33: inputParam.adr1_telno33,
                adr1_telendstr3: inputParam.adr1_telendstr3,
                corp1_maekabu: inputParam.corp1_maekabu,
                corp1_name: inputParam.corp1_name,
                corp1_busyo: inputParam.corp1_busyo,

                // 【注意】組版側は
                // fname→姓、fruby→姓ルビ、lname→名、lruby→名ルビ
                // として動作します(英語の意味とは逆)
                name1_title: inputParam.name1_title,
                name1_fname: inputParam.name1_lname,
                name1_lname: inputParam.name1_fname,
                name1_ps: inputParam.name1_ps,
                name1_fruby: inputParam.name1_lruby,
                name1_lruby: inputParam.name1_fruby,

                name2_title: inputParam.name2_title,
                name2_fname: inputParam.name2_lname,
                name2_lname: inputParam.name2_fname,
                name2_ps: inputParam.name2_ps,
                name2_fruby: inputParam.name2_lruby,
                name2_lruby: inputParam.name2_fruby,

                name3_title: inputParam.name3_title,
                name3_fname: inputParam.name3_lname,
                name3_lname: inputParam.name3_fname,
                name3_ps: inputParam.name3_ps,
                name3_fruby: inputParam.name3_lruby,
                name3_lruby: inputParam.name3_fruby,

                name4_title: inputParam.name4_title,
                name4_fname: inputParam.name4_lname,
                name4_lname: inputParam.name4_fname,
                name4_ps: inputParam.name4_ps,
                name4_fruby: inputParam.name4_lruby,
                name4_lruby: inputParam.name4_fruby,

                name5_title: inputParam.name5_title,
                name5_fname: inputParam.name5_lname,
                name5_lname: inputParam.name5_fname,
                name5_ps: inputParam.name5_ps,
                name5_fruby: inputParam.name5_lruby,
                name5_lruby: inputParam.name5_fruby,

                name6_title: inputParam.name6_title,
                name6_fname: inputParam.name6_lname,
                name6_lname: inputParam.name6_fname,
                name6_ps: inputParam.name6_ps,
                name6_fruby: inputParam.name6_lruby,
                name6_lruby: inputParam.name6_fruby,

                eh1_topstr: inputParam.eh1_topstr,
                eh1_mailtype: inputParam.eh1_mailtype,
                eh1_adr: inputParam.eh1_adr,
                eh1_endstr: inputParam.eh1_endstr,

                eh2_topstr: inputParam.eh2_topstr,
                eh2_mailtype: inputParam.eh2_mailtype,
                eh2_adr: inputParam.eh2_adr,
                eh2_endstr: inputParam.eh2_endstr,

                staff: inputParam.staff,


            }
        };

        Logger.log("差出人 組版実行 [" + JSON.stringify(param) + "]");

        await util.ajax.post(this.kumihanUrl + this.WEBAPI_URL_SENDER, JSON.stringify(param)).then((resData: kumihanResponseParam) => {

            Logger.debug("差出人 組版結果OK [" + JSON.stringify(resData) + "]");

            result = resData;
        }).catch((e: Error) => {

            Logger.error("差出人 組版結果NG", e);

        });

        return result;

    }

    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------

}

/**
 * 組版API リクエストパラメータ(共通部)
 */
export class kumihanRequestParam {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------


    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------

    /**
     * 組版トークン
     */
    public session: string;

    /**
     * 組方向
     */
    public hv: edconst.kumihanHv;

    /**
     * 文字サイズ(pt)
     */
    public msize: number;

    /**
     * 原点
     */
    public pivot: number;

    /**
     * デザインマスタの幅
     */
    public width: number;

    /**
     * デザインマスタの高さ
     */
    public height: number;

    /**
     * 組版の幅
     */
    public widthKumi: number;

    /**
     * 組版の高さ
     */
    public heightKumi: number;


    /**
     * フォント名
     */
    public ftype: string;

    /**
     * 文字色
     */
    public color1: string;

    /**
     * フチ文字色
     */
    public color2: string;

    /**
     * 縦組時単位変換するか？
     * /// 1: 123 → 百二十三 的な変換
     * /// 2: 単純変換 123 → 一二三 てきな変換
     * デフォルト変換しない。
     * */
    public vertGreetConvType: number = edconst.EditConst.GREETING_VERT_CONV;

    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------


    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------
    /**
     * コンストラクタ
     * */
    constructor() {
    }

    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------

}

/**
 * 組版API レスポンスパラメータ
 */
export class kumihanResponseParam {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------


    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------

    /**
     * 組版結果
     */
    public json: string;

    /**
     * 組版結果
     */
    public templid: string;


    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------
    /**
     * コンストラクタ
     * */
    constructor() {
    }

    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------

}


/**
 * あいさつ文組版API リクエストパラメータ
 */
export class kumihanGreetingRequestParam extends kumihanRequestParam {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------


    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------

    /**
     * 文章
     */
    public payload: string[];


    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------


    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------

}

/**
 * 差出人 組版API リクエストパラメータ
 */
export class kumihanSenderRequestParam extends kumihanRequestParam {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------


    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------

    /**
     * レイアウト記号
     */
    public layout_cd: string;

    /**
     * 住所頭書き
     */
    public adr1_topstr: string;

    /**
     * 郵便番号１
     */
    public adr1_post1: string;

    /**
     * 郵便番号２
     */
    public adr1_post2: string;

    /**
     * 住所１
     */
    public adr1_adr1: string;

    /**
     * 住所２
     */
    public adr1_adr2: string;

    /**
     * 住所３
     */
    public adr1_adr3: string;

    /**
     * 電話番号タイプ１
     */
    public adr1_teltype1: string;

    /**
     * 電話番号前文字１
     */
    public adr1_teltopstr1: string;

    /**
     * 電話番号１
     */
    public adr1_telno1: string;

    /**
     * 電話番号１－１
     */
    public adr1_telno11: string;

    /**
     * 電話番号１－２
     */
    public adr1_telno12: string;

    /**
     * 電話番号１－３
     */
    public adr1_telno13: string;

    /**
     * 電話番号後文字１
     */
    public adr1_telendstr1: string;

    /**
     * 電話番号タイプ２
     */
    public adr1_teltype2: string;

    /**
     * 電話番号前文字２
     */
    public adr1_teltopstr2: string;

    /**
     * 電話番号２
     */
    public adr1_telno2: string;

    /**
     * 電話番号２－１
     */
    public adr1_telno21: string;

    /**
     * 電話番号２－２
     */
    public adr1_telno22: string;

    /**
     * 電話番号２－３
     */
    public adr1_telno23: string;

    /**
     * 電話番号後文字２
     */
    public adr1_telendstr2: string;

    /**
     * 電話番号タイプ３
     */
    public adr1_teltype3: string;

    /**
     * 電話番号前文字３
     */
    public adr1_teltopstr3: string;

    /**
     * 電話番号３
     */
    public adr1_telno3: string;

    /**
     * 電話番号３－１
     */
    public adr1_telno31: string;

    /**
     * 電話番号３－２
     */
    public adr1_telno32: string;

    /**
     * 電話番号３－３
     */
    public adr1_telno33: string;

    /**
     * 電話番号後文字３
     */
    public adr1_telendstr3: string;

    /**
     * 前株
     */
    public corp1_maekabu: string;

    /**
     * 会社名
     */
    public corp1_name: string;

    /**
     * 部署名
     */
    public corp1_busyo: string;

    /**
     * 肩書
     */
    public name1_title: string;
    /**
     * 姓
     */
    public name1_fname: string;
    /**
     * 名
     */
    public name1_lname: string;
    /**
     * 添書き
     */
    public name1_ps: string;
    /**
     * 姓ルビ
     */
    public name1_fruby: string;
    /**
     * 名ルビ
     */
    public name1_lruby: string;

    /**
     * 肩書
     */
    public name2_title: string;
    /**
     * 姓
     */
    public name2_fname: string;
    /**
     * 名
     */
    public name2_lname: string;
    /**
     * 添書き
     */
    public name2_ps: string;
    /**
     * 姓ルビ
     */
    public name2_fruby: string;
    /**
     * 名ルビ
     */
    public name2_lruby: string;

    /**
     * 肩書
     */
    public name3_title: string;
    /**
     * 姓
     */
    public name3_fname: string;
    /**
     * 名
     */
    public name3_lname: string;
    /**
     * 添書き
     */
    public name3_ps: string;
    /**
     * 姓ルビ
     */
    public name3_fruby: string;
    /**
     * 名ルビ
     */
    public name3_lruby: string;

    /**
     * 肩書
     */
    public name4_title: string;
    /**
     * 姓
     */
    public name4_fname: string;
    /**
     * 名
     */
    public name4_lname: string;
    /**
     * 添書き
     */
    public name4_ps: string;
    /**
     * 姓ルビ
     */
    public name4_fruby: string;
    /**
     * 名ルビ
     */
    public name4_lruby: string;

    /**
     * 肩書
     */
    public name5_title: string;
    /**
     * 姓
     */
    public name5_fname: string;
    /**
     * 名
     */
    public name5_lname: string;
    /**
     * 添書き
     */
    public name5_ps: string;
    /**
     * 姓ルビ
     */
    public name5_fruby: string;
    /**
     * 名ルビ
     */
    public name5_lruby: string;

    /**
     * 肩書
     */
    public name6_title: string;
    /**
     * 姓
     */
    public name6_fname: string;
    /**
     * 名
     */
    public name6_lname: string;
    /**
     * 添書き
     */
    public name6_ps: string;
    /**
     * 姓ルビ
     */
    public name6_fruby: string;
    /**
     * 名ルビ
     */
    public name6_lruby: string;


    /**
     * 頭書き
     */
    public eh1_topstr: string;
    /**
     * メールタイプ
     */
    public eh1_mailtype: string;
    /**
     * アドレス
     */
    public eh1_adr: string;
    /**
     * 後書き
     */
    public eh1_endstr: string;

    /**
     * 頭書き
     */
    public eh2_topstr: string;
    /**
     * メールタイプ
     */
    public eh2_mailtype: string;
    /**
     * アドレス
     */
    public eh2_adr: string;
    /**
     * 後書き
     */
    public eh2_endstr: string;


    /**
     * スタッフ
     */
    public staff: string;



    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------


    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------


    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------

    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------

}

// #endregion

